export default function WhyChooseUs() {
  const reasons = [
    {
      title: 'ATOL Protected',
      description: 'All our packages are ATOL protected, ensuring your financial security and peace of mind',
      icon: 'ri-shield-check-line'
    },
    {
      title: '15+ Years Experience',
      description: 'Over a decade of expertise in organizing spiritual journeys to the Holy Cities',
      icon: 'ri-award-line'
    },
    {
      title: 'Trusted by Thousands',
      description: 'Thousands of satisfied pilgrims have completed their journeys with us',
      icon: 'ri-team-line'
    },
    {
      title: 'Personalized Service',
      description: 'Dedicated travel advisors who understand your needs and preferences',
      icon: 'ri-user-heart-line'
    }
  ];

  return (
    <section className="py-24 bg-[#1A1F2E] text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#C9A961] text-lg mb-4 italic" style={{ fontFamily: 'Playfair Display, serif' }}>
            /Your Trusted Partner
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Why Choose Alwaz Travel
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            We are committed to making your sacred journey as smooth, comfortable, and spiritually fulfilling as possible
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="text-center p-8 bg-white/5 rounded-2xl hover:bg-white/10 transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-[#C9A961] rounded-full">
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold mb-3">{reason.title}</h3>
              <p className="text-gray-300 text-sm leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
